import React, { useEffect, useState, useContext } from 'react';
import { Form, Spin } from 'antd';
import {
  getOfferDetailByOfferId,
  ParOfferTargetConversionResponse,
} from 'services/pricing';
import { useParams, useNavigate } from 'react-router-dom';
import { useQuery } from 'react-query';
import { useForm } from 'antd/lib/form/Form';
import DF from 'DisplayFramework';
import TitlePage from 'components/theme_components/Title';
import { AuthContext } from 'components/Auth/Auth';
import ProductRecapContent from './ProductRecapContent';

interface SortieData {
  isAutomaticConversion?: boolean;
  isCapitalRepayment?: boolean;
  offeridtarget?: number;
  targetprcode?: string;
  offerlabel?: string;
}

const RecapProduct: React.FC = () => {
  const navigate = useNavigate();
  const { isInspect } = useContext(AuthContext);
  const [form] = useForm();

  const [rateList, setRateList] = useState<any[]>([]);
  const [partList, setPartList] = useState<any[]>([]);
  const [localFeesList, setLocalFeesList] = useState<any[]>([]);
  const [triggersList, setLocalTriggersList] = useState<any[]>([]);
  const [localSortieData, setLocalSortieData] = useState<SortieData>({});
  const [localConversionList, setLocalConversionList] = useState<
    ParOfferTargetConversionResponse[]
  >([]);
  const [localAmortizationList, setLocalAmortizationList] = useState<any[]>([]);
  const { id } = useParams<{ id: string }>();

  const { data: offer, isFetching } = useQuery(
    ['getOfferDetailByOfferId', { offerid: id }],
    () =>
      getOfferDetailByOfferId({ offerid: Number(id) }).then((res) => res.data),
    {
      enabled: !!id,
    }
  );

  useEffect(() => {
    if (offer) {
      form.setFieldsValue({ ...offer });


      const fullList = offer.prefinStepList ?? [];

      // Séparation en 2 listes distinctes
      const intSteps = fullList.filter(
        (step: any) =>
          step.prefinsteptype === 'INT'
      );


      const partSteps = fullList.filter(
        (step: any) =>
          step.prefinsteptype === 'PART'
      );


      const amortizationSteps = fullList.filter(
        (step: any) => step.prefinsteptype === 'CAP'
      );
      setLocalAmortizationList(amortizationSteps);
      setRateList(intSteps);
      setPartList(partSteps)
      setLocalAmortizationList(amortizationSteps);

      setLocalFeesList(offer.feesList ?? []);
      setLocalTriggersList(offer.triggersList ?? []);
      setLocalConversionList(offer.targetConversions ?? []);
      setLocalSortieData({
        isAutomaticConversion: offer.isAutomaticConversion,
        isCapitalRepayment: offer.isCapitalRepayment,
        offeridtarget: offer.offeridtarget,
        offerlabel: offer.offerlabel,
        targetprcode: offer.prcode,
      });
    }
  }, [form, offer]);

  // const handleFormChange = (changedValues: any, allValues: any) => {
  //   // Update local state based on form changes
  //   if (changedValues.conversionProducts) {
  //     setLocalConversionList(changedValues.conversionProducts);
  //   }

  //   if (changedValues.conversionFlag !== undefined) {
  //     const isManualConversion = changedValues.conversionFlag === 'oui';
  //     setLocalSortieData(prev => ({
  //       ...prev,
  //       isAutomaticConversion: isManualConversion,
  //       isCapitalRepayment: !isManualConversion,
  //     }));

  //     // If switching to "non", clear conversion list
  //     if (!isManualConversion) {
  //       setLocalConversionList([]);
  //     }
  //   }

  //   // Handle other form changes as needed
  //   if (changedValues.prefinStepList) {
  //     const fullList = changedValues.prefinStepList ?? [];
  //     const prefinSteps = fullList.filter(
  //       (step: any) =>
  //         step.prefinsteptype === 'PART' || step.prefinsteptype === 'INT'
  //     );
  //     const amortizationSteps = fullList.filter(
  //       (step: any) => step.prefinsteptype === 'CAP'
  //     );
  //     setLocalPrefinlist(prefinSteps);
  //     setLocalAmortizationList(amortizationSteps);
  //   }

  //   if (changedValues.feesList) {
  //     setLocalFeesList(changedValues.feesList);
  //   }

  //   if (changedValues.triggersList) {
  //     setLocalTriggersList(changedValues.triggersList);
  //   }
  // };
  return (
    // eslint-disable-next-line react/jsx-pascal-case
    <DF.Provider pagcode="productlist">
      <TitlePage
        level={2}
        comcode="recap"
        bgColor="purple"
        noTitleOverlay
        onPrev={() => navigate(`/configuration-sfs?tab=2`)}
      />

      <Spin spinning={isFetching}>
        <Form className="recap-container productlist mt-4">
          <ProductRecapContent
            form={form}
            ratelist={rateList}
            partlist={partList}
            feesList={localFeesList}
            servicesList={[]}
            triggersList={triggersList}
            amortizationList={localAmortizationList}
            sortieData={localSortieData}
            conversionList={localConversionList}
            isInspect={isInspect}
            isEditable={false}
            onEditSection={undefined} />
        </Form>
      </Spin>
    </DF.Provider>
  );
};

export default RecapProduct;
